<div class="ai-panel-overlay" role="dialog" aria-modal="true"
  [attr.aria-label]="'ai-extraction.title' | translate">
  <div class="ai-panel-overlay__backdrop" (click)="requestClose()"></div>

  <div class="ai-panel" [class.ai-panel--wide]="step === 'review'">
    <header class="ai-panel__header">
      <div class="ai-panel__title">
        <span class="ai-panel__icon"><i class="ri-sparkling-2-fill"></i></span>
        <div>
          <h5>{{ 'ai-extraction.title' | translate }}</h5>
          <p>{{ 'ai-extraction.subtitle' | translate }}</p>
        </div>
      </div>

      <ol class="ai-steps" aria-hidden="true">
        <li [class.is-active]="step === 'upload'" [class.is-done]="step !== 'upload' && step !== 'loading' && step !== 'error'">
          {{ 'ai-extraction.steps.upload' | translate }}
        </li>
        <li [class.is-active]="step === 'triage' || step === 'quote'"
          [class.is-done]="step === 'processing' || step === 'review'">
          {{ 'ai-extraction.steps.quote' | translate }}
        </li>
        <li [class.is-active]="step === 'processing'" [class.is-done]="step === 'review'">
          {{ 'ai-extraction.steps.reading' | translate }}
        </li>
        <li [class.is-active]="step === 'review'">{{ 'ai-extraction.steps.review' | translate }}</li>
      </ol>

      <button type="button" class="btn-close" [attr.aria-label]="'ai-extraction.close.label' | translate"
        (click)="requestClose()"></button>
    </header>

    <div class="ai-panel__body">
      <div class="alert alert-danger ai-panel__error" *ngIf="errorMessage && step !== 'error'" role="alert">
        {{ errorMessage }}
      </div>

      <div class="alert alert-warning ai-panel__error" *ngIf="rejectedNotes.length" role="status">
        <strong>{{ 'ai-extraction.rejected.title' | translate }}</strong>
        <ul class="mb-0">
          <li *ngFor="let note of rejectedNotes">{{ note }}</li>
        </ul>
      </div>

      <!-- A carregar -->
      <div class="ai-panel__center" *ngIf="step === 'loading'" aria-live="polite">
        <div class="spinner-border text-primary" role="status"></div>
        <p>{{ 'ai-extraction.loading' | translate }}</p>
      </div>

      <!-- Erro -->
      <div class="ai-panel__center" *ngIf="step === 'error'" role="alert">
        <i class="ri-error-warning-line ai-panel__big-icon text-danger"></i>
        <p>{{ errorMessage }}</p>
        <button type="button" class="btn btn-primary" (click)="backToUpload()" *ngIf="!propertyFileIds?.length">
          {{ 'ai-extraction.errors.try-again' | translate }}
        </button>
      </div>

      <!-- 1. Carregar -->
      <div class="ai-upload" *ngIf="step === 'upload'">
        <label class="ai-dropzone" [class.is-dragging]="dragging" (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
          <input type="file" class="visually-hidden" multiple [accept]="accept" (change)="onFilesChosen($event)" />
          <i class="ri-upload-cloud-2-line"></i>
          <strong>{{ 'ai-extraction.upload.drop' | translate }}</strong>
          <span>{{ 'ai-extraction.upload.hint' | translate }}</span>
          <span class="ai-dropzone__formats">
            PDF, JPG, PNG, WEBP · {{ 'ai-extraction.upload.max' | translate }} {{ config?.limits?.maxFileMb }} MB
          </span>
        </label>

        <div class="ai-pricing" *ngIf="config">
          <div class="ai-pricing__item">
            <span class="badge badge-soft-primary">{{ 'ai-extraction.category.printed' | translate }}</span>
            <strong>{{ config.pricing.printedDocument }}</strong>
            <small>{{ 'ai-extraction.pricing.per-document' | translate }}</small>
          </div>
          <div class="ai-pricing__item">
            <span class="badge badge-soft-warning">{{ 'ai-extraction.category.handwritten' | translate }}</span>
            <strong>{{ config.pricing.handwrittenDocument }}</strong>
            <small>{{ 'ai-extraction.pricing.per-document' | translate }}</small>
          </div>
          <div class="ai-pricing__item">
            <span class="badge badge-soft-info">{{ 'ai-extraction.category.image' | translate }}</span>
            <strong>{{ config.pricing.imageBatch }}</strong>
            <small>{{ 'ai-extraction.pricing.per-batch' | translate }} {{ config.pricing.imageBatchSize }}</small>
          </div>
          <p class="ai-pricing__note">{{ 'ai-extraction.pricing.note' | translate }}</p>
        </div>

        <ul class="ai-files" *ngIf="pendingFiles.length">
          <li *ngFor="let file of pendingFiles; trackBy: trackByKey">
            <i class="ri-file-line"></i>
            <span class="ai-files__name">{{ file.name }}</span>
            <span class="ai-files__size">{{ file.sizeLabel }}</span>
            <button type="button" class="btn btn-sm btn-ghost-danger"
              [attr.aria-label]="'ai-extraction.upload.remove' | translate" (click)="removePending(file)">
              <i class="ri-close-line"></i>
            </button>
          </li>
        </ul>
      </div>

      <!-- 2a. Triagem e 3. leitura: progresso real por documento -->
      <div class="ai-progress" *ngIf="step === 'triage' || step === 'processing'" aria-live="polite">
        <h6>
          {{ (step === 'triage' ? 'ai-extraction.progress.triage' : 'ai-extraction.progress.reading') | translate }}
        </h6>
        <p class="text-muted">
          {{ (step === 'triage' ? 'ai-extraction.progress.triage-hint' : 'ai-extraction.progress.reading-hint') | translate }}
        </p>
        <div class="progress ai-progress__bar" role="progressbar" [attr.aria-valuenow]="progressPct"
          aria-valuemin="0" aria-valuemax="100">
          <div class="progress-bar progress-bar-striped progress-bar-animated" [style.width.%]="progressPct"></div>
        </div>

        <ul class="ai-progress__list">
          <li *ngFor="let row of progressRows; trackBy: trackById" [attr.data-state]="row.state">
            <span class="ai-progress__state">
              <span class="spinner-border spinner-border-sm" *ngIf="row.state === 'working'" role="status"></span>
              <i class="ri-check-line" *ngIf="row.state === 'done'"></i>
              <i class="ri-close-line" *ngIf="row.state === 'failed'"></i>
              <i class="ri-time-line" *ngIf="row.state === 'waiting'"></i>
            </span>
            <span class="ai-progress__name">{{ row.fileName }}</span>
            <span class="ai-progress__status">{{ row.statusKey | translate }}</span>
          </li>
        </ul>
      </div>

      <!-- 2b. Orçamento -->
      <div class="ai-quote" *ngIf="step === 'quote' && run">
        <div class="table-responsive">
          <table class="table table-sm align-middle ai-quote__table">
            <thead>
              <tr>
                <th>{{ 'ai-extraction.quote.document' | translate }}</th>
                <th>{{ 'ai-extraction.quote.recognised' | translate }}</th>
                <th>{{ 'ai-extraction.quote.category' | translate }}</th>
                <th class="text-end">{{ 'ai-extraction.quote.pages' | translate }}</th>
                <th class="text-end">{{ 'ai-extraction.credits' | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of quoteRows; trackBy: trackById" [class.is-muted]="!row.readable">
                <td class="ai-quote__name">
                  {{ row.fileName }}
                  <small class="d-block text-danger" *ngIf="row.note">{{ row.note }}</small>
                </td>
                <td>{{ row.typeKey | translate }}</td>
                <td>
                  <span class="badge" [ngClass]="row.categoryClass" *ngIf="row.readable">
                    {{ row.categoryKey | translate }}
                  </span>
                  <span class="badge badge-soft-secondary" *ngIf="!row.readable">
                    {{ 'ai-extraction.quote.not-charged' | translate }}
                  </span>
                </td>
                <td class="text-end">{{ row.pageCount }}</td>
                <td class="text-end fw-semibold">{{ row.credits }}</td>
                <td class="text-end">
                  <button type="button" class="btn btn-sm btn-ghost-danger" [disabled]="busy"
                    [attr.aria-label]="'ai-extraction.upload.remove' | translate" (click)="removeDocument(row)">
                    <i class="ri-delete-bin-line"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <label class="btn btn-sm btn-soft-primary ai-quote__add" [class.disabled]="busy">
          <input type="file" class="visually-hidden" multiple [accept]="accept" [disabled]="busy"
            (change)="onFilesChosen($event)" />
          <i class="ri-add-line me-1"></i>{{ 'ai-extraction.quote.add' | translate }}
        </label>

        <div class="ai-ledger">
          <div class="ai-ledger__row" *ngIf="run.quote.printed.count">
            <span>{{ run.quote.printed.count }} × {{ 'ai-extraction.category.printed' | translate }}</span>
            <span>{{ run.quote.printed.credits }}</span>
          </div>
          <div class="ai-ledger__row" *ngIf="run.quote.handwritten.count">
            <span>{{ run.quote.handwritten.count }} × {{ 'ai-extraction.category.handwritten' | translate }}</span>
            <span>{{ run.quote.handwritten.credits }}</span>
          </div>
          <div class="ai-ledger__row" *ngIf="run.quote.images.count">
            <span>
              {{ run.quote.images.count }} × {{ 'ai-extraction.category.image' | translate }}
              ({{ run.quote.images.batches }} {{ 'ai-extraction.quote.batches' | translate }})
            </span>
            <span>{{ run.quote.images.credits }}</span>
          </div>
          <div class="ai-ledger__row" *ngIf="run.quote.extraPages.credits">
            <span>{{ run.quote.extraPages.pages }} {{ 'ai-extraction.quote.extra-pages' | translate }}</span>
            <span>{{ run.quote.extraPages.credits }}</span>
          </div>
          <div class="ai-ledger__row ai-ledger__row--total">
            <span>{{ 'ai-extraction.quote.total' | translate }}</span>
            <span>{{ run.quotedCredits }} {{ 'ai-extraction.credits' | translate }}</span>
          </div>
          <div class="ai-ledger__row ai-ledger__row--balance" *ngIf="balance !== null">
            <span>{{ 'ai-extraction.quote.balance' | translate }}</span>
            <span>{{ balance }}</span>
          </div>
          <div class="ai-ledger__row ai-ledger__row--balance" *ngIf="balanceAfter !== null"
            [class.text-danger]="insufficient">
            <span>{{ 'ai-extraction.quote.balance-after' | translate }}</span>
            <span>{{ balanceAfter }}</span>
          </div>
        </div>

        <p class="ai-quote__note">
          <i class="ri-shield-check-line me-1"></i>{{ 'ai-extraction.quote.note' | translate }}
        </p>
        <p class="ai-quote__note">
          <i class="ri-information-line me-1"></i>{{ 'ai-feedback.securityNoticeBody' | translate }}
        </p>
      </div>

      <!-- 4. Revisão -->
      <app-ai-extraction-review *ngIf="step === 'review' && result" [result]="result" [lookups]="lookups"
        [currentValues]="currentValues" [documentTypes]="documentTypes" [saving]="saving"
        (confirmed)="onConfirmed($event)" (retryDocument)="onRetryDocument($event)"
        (closed)="requestClose()"></app-ai-extraction-review>
    </div>

    <footer class="ai-panel__footer" *ngIf="step === 'upload' || step === 'quote' || step === 'processing'">
      <ng-container *ngIf="step === 'upload'">
        <span class="ai-panel__footer-note">
          {{ pendingFiles.length }} / {{ maxFiles }} {{ 'ai-extraction.upload.files' | translate }}
        </span>
        <button type="button" class="btn btn-primary" [disabled]="!pendingFiles.length || busy" (click)="createRun()">
          <span class="spinner-border spinner-border-sm me-1" *ngIf="busy" role="status"></span>
          {{ 'ai-extraction.upload.analyse' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="step === 'quote' && run">
        <button type="button" class="btn btn-light" [disabled]="busy" (click)="cancelRun()">
          {{ 'ai-extraction.cancel.action' | translate }}
        </button>
        <span class="ai-panel__footer-note text-danger" *ngIf="insufficient">
          {{ 'ai-extraction.quote.insufficient' | translate }}
        </span>
        <span class="ai-panel__footer-note" *ngIf="!insufficient"></span>
        <button type="button" class="btn btn-primary" [disabled]="busy || insufficient || run.quotedCredits < 0"
          (click)="confirm()">
          <span class="spinner-border spinner-border-sm me-1" *ngIf="busy" role="status"></span>
          {{ 'ai-extraction.quote.confirm' | translate }} · {{ run.quotedCredits }} {{ 'ai-extraction.credits' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="step === 'processing'">
        <button type="button" class="btn btn-light" (click)="cancelRun()">
          {{ 'ai-extraction.cancel.action' | translate }}
        </button>
        <span class="ai-panel__footer-note">{{ 'ai-extraction.progress.can-close' | translate }}</span>
      </ng-container>
    </footer>
  </div>
</div>
